export default __webpack_public_path__ + "static/media/banner2.8c1a9255.png";